import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/contact/')({
  component: () => <div>Hello /_authenticated/contact/!</div>,
})
